module.exports = __webpack_public_path__ + "static/media/hero-img.5f13d8c1.jpeg";